import { Grid } from '@mui/material';
import { ISubmissionSettingsResponse } from 'wisestep-api';
import { ControlledWsButtonGroup, RenderTextInput } from 'wisestep-base';

const formLabel = (label: string, isRequired: boolean) => label + (isRequired ? '*' : '');
const ExEmployeeClientFormFileds = ({
  submissionSetting,
}: {
  submissionSetting: ISubmissionSettingsResponse;
}) => {
  return (
    <>
      {submissionSetting?.exEmployeeOfClient && !submissionSetting?.exEmployeeOfClient?.hidden && (
        <Grid ml={2}>
          <ControlledWsButtonGroup
            name="exEmployeeOfClient"
            inputTitle="Ex Employee Client "
            buttonsList={['Yes', 'No']}
            showMandatorySymbol={submissionSetting?.exEmployeeOfClient?.required ?? false}
          />
        </Grid>
      )}
      {submissionSetting?.exEmployeeId && !submissionSetting?.exEmployeeId?.hidden && (
        <RenderTextInput
          name="exEmployeeId"
          labelText={formLabel(
            'Ex Employee ID ',
            submissionSetting?.exEmployeeId?.required ?? false
          )}
          placeholder="Enter Ex Employee ID"
        />
      )}
      {submissionSetting?.portalId && !submissionSetting?.portalId?.hidden && (
        <RenderTextInput
          name="portalId"
          labelText={formLabel('Portal ID ', submissionSetting?.portalId?.required ?? false)}
          placeholder="Enter Portal ID"
        />
      )}
    </>
  );
};

export default ExEmployeeClientFormFileds;
